document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[id^="carouselDescription-"]').forEach((descEl) => {
      const id = descEl.id.split('carouselDescription-')[1];
      const toggle = document.getElementById(`carouselReadMore-${id}`);
      const input = document.getElementById(`carousel-description-toggle-${id}`);
  
      if (!toggle || !descEl || !input) return;
      if (window.innerWidth >= 768) return;
  
      const clone = descEl.cloneNode(true);
      clone.style.cssText = `
        visibility: hidden;
        position: absolute;
        height: auto;
        display: block;
        -webkit-line-clamp: unset;
        white-space: normal;
        width: ${descEl.offsetWidth}px;
      `;
      document.body.appendChild(clone);
  
      const fullHeight = clone.offsetHeight;
      const lineHeight = parseFloat(getComputedStyle(descEl).lineHeight) || 24;
      const visibleHeight = lineHeight * 3;
  
      document.body.removeChild(clone);
  
      if (fullHeight > visibleHeight) {
        toggle.style.display = 'inline-block';
      } else {
        toggle.style.display = 'none';
      }
    });
  });
  